<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="form" class="toolbar">
        <el-form-item label="统计周期">
          <el-select v-model="form.periodType" style="width:100px" @change="loadAll">
            <el-option label="日" value="day" />
            <el-option label="周" value="week" />
            <el-option label="月" value="month" />
          </el-select>
        </el-form-item>
        <el-form-item label="自定义范围">
          <el-date-picker v-model="form.dateRange" type="daterange" value-format="yyyy-MM-dd" @change="loadAll" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="loadAll">刷新</el-button>
        </el-form-item>
      </el-form>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="执行率统计" name="execution">
          <el-row :gutter="16" v-if="execution" class="stat-cards">
            <el-col :span="6"><div class="stat-box"><div class="t">应执行</div><div class="v">{{ execution.totalTasks }}</div></div></el-col>
            <el-col :span="6"><div class="stat-box"><div class="t">已完成</div><div class="v">{{ execution.completedTasks }}</div></div></el-col>
            <el-col :span="6"><div class="stat-box"><div class="t">执行率(%)</div><div class="v">{{ execution.executionRate }}</div></div></el-col>
            <el-col :span="6"><div class="stat-box"><div class="t">超时率(%)</div><div class="v">{{ execution.timeoutRate }}</div></div></el-col>
          </el-row>
          <el-table v-if="execution && execution.dailyTrend" :data="execution.dailyTrend" style="margin-top:16px">
            <el-table-column label="日期" prop="date" align="center" />
            <el-table-column label="应执行" prop="total" align="center" />
            <el-table-column label="已完成" prop="completed" align="center" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="工作量统计" name="workload">
          <el-table :data="workloadRows">
            <el-table-column label="护工" prop="executorName" align="center" />
            <el-table-column label="任务数" prop="taskCount" align="center" />
            <el-table-column label="完成数" prop="completedCount" align="center" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="超时率统计" name="timeout">
          <el-row :gutter="16" v-if="timeout" class="stat-cards">
            <el-col :span="8"><div class="stat-box"><div class="t">总任务</div><div class="v">{{ timeout.totalTasks }}</div></div></el-col>
            <el-col :span="8"><div class="stat-box"><div class="t">超时任务</div><div class="v">{{ timeout.timeoutTasks }}</div></div></el-col>
            <el-col :span="8"><div class="stat-box"><div class="t">超时率(%)</div><div class="v">{{ timeout.timeoutRate }}</div></div></el-col>
          </el-row>
          <el-table v-if="timeout" :data="timeout.hourlyDistribution" style="margin-top:16px">
            <el-table-column label="时段(时)" prop="hour" align="center" />
            <el-table-column label="超时次数" prop="cnt" align="center" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: "NursingStatsDashboard",
  data() {
    return {
      activeTab: "execution",
      form: { periodType: "week", dateRange: null },
      execution: null,
      workloadRows: [],
      timeout: null
    };
  },
  methods: {
    buildQuery() {
      const q = { periodType: this.form.periodType };
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        q.startDate = this.form.dateRange[0];
        q.endDate = this.form.dateRange[1];
      }
      return q;
    },
    loadAll() {
      const q = this.buildQuery();
      this.$postJson("omc/nursingStats/execution", q).then(res => {
        if (res.code == 200) this.execution = res.result;
      });
      this.$postJson("omc/nursingStats/workload", q).then(res => {
        if (res.code == 200 && res.result) this.workloadRows = res.result.byExecutor || [];
      });
      this.$postJson("omc/nursingStats/timeout", q).then(res => {
        if (res.code == 200) this.timeout = res.result;
      });
    }
  },
  mounted() {
    const tab = this.$route.meta && this.$route.meta.statsTab;
    if (tab) this.activeTab = tab;
    this.loadAll();
  }
};
</script>
<style scoped>
.stat-box { background:#f5f7fa; border-radius:6px; padding:16px; text-align:center; }
.stat-box .t { font-size:13px; color:#666; }
.stat-box .v { font-size:24px; font-weight:600; color:#1395DB; margin-top:8px; }
</style>
